export const FautrasLogo = ({ className = "", dark = false }) => {
  const base = dark ? "#FFFFFF" : "#434343";
  const src = `${process.env.PUBLIC_URL}/fautras-wordmark-${dark ? "white" : "dark"}.png`;
  return (
    <div className={`inline-flex flex-col leading-none ${className}`} data-testid="fautras-logo">
      <img src={src} alt="FAUTRAS" className="h-6 sm:h-7 w-auto block" />
      <span
        className="font-heading font-medium text-xs sm:text-sm mt-1.5 block w-full"
        style={{ color: base, letterSpacing: "0.2em", textAlign: "justify", textAlignLast: "justify" }}
      >
        COMPLICE DU CHEVAL
      </span>
    </div>
  );
};

export default FautrasLogo;
